import { useEffect, useState, useMemo, useCallback } from 'react'

import {
  MOBILE_HOME_TABS,
  START_DATE_QUARTER_DATA,
  TODAY_DATE,
} from '../../common/constants'
import { useInfiniteShippingsTracking } from '../../services/shippingsTracking'
// TODO Desligar la lógica o datos necesarios de la vista independiente de ShippingsTracking
import { haveFiltersDefaultDatePeriod } from '../../App/ShippingsTracking/useQueryParamsFilters'
import useNearElement from '../../hooks/useNearElement'

const STATIC_DEFAULT_FILTERS = {
  postalCodeSource: 'destin',
  dateFrom: START_DATE_QUARTER_DATA,
  dateTo: TODAY_DATE,
}

const useShippingsTab = ({ type, centerHideId, statusList = [] }) => {
  const { isNearElement, fromRef } = useNearElement({
    once: false,
    distance: '200px',
  })

  const defaultFiltersByType = useMemo(
    () =>
      type === MOBILE_HOME_TABS.SHIPMENTS
        ? { statusCode: undefined, hasIncident: undefined }
        : type === MOBILE_HOME_TABS.INCIDENTS
        ? { statusCode: undefined, hasIncident: true }
        : {
            statusCode: ['WEB0000'],
            hasIncident: false,
            isUnscheduledPickupSearch: true
          },
    [type],
  )

  const defaultFilters = useMemo(
    () => ({
      statusCode: [],
      ...STATIC_DEFAULT_FILTERS,
      ...defaultFiltersByType,
      clientCenterCode: centerHideId,
    }),
    [centerHideId, defaultFiltersByType],
  )

  const [filters, setFilters] = useState(defaultFilters)

  const [lastCenterHideId, setLastCenterHideId] = useState(centerHideId)

  useEffect(() => {
    if (lastCenterHideId !== centerHideId) {
      setFilters(currentFilters => ({
        ...currentFilters,
        clientCenterCode: centerHideId,
      }))
      setLastCenterHideId(centerHideId)
    }
  }, [centerHideId, lastCenterHideId])

  const queryConfig = useMemo(
    () => ({
      enabled:
        filters?.clientCenterCode !== undefined && Boolean(statusList?.length),
    }),
    [filters?.clientCenterCode, statusList?.length],
  )

  const { data, fetchNextPage, isLoading } = useInfiniteShippingsTracking(
    filters,
    statusList,
    queryConfig,
    type,
  )

  const resetFilters = useCallback(() => {
    setFilters(defaultFilters)
  }, [defaultFilters])

  const updateFilters = useCallback(
    newFilters => {
      setFilters({ ...defaultFilters, ...newFilters })
    },
    [defaultFilters],
  )

  const getAppliedFiltersNumber = useCallback(
    (filters = {}) => {
      const getFiltersNumber = filters =>
        Object.values(filters).filter(value => Boolean(value)).length
      const totalAppliedFiltersNumber = getFiltersNumber(filters)
      const defaultFiltersNumber = getFiltersNumber(defaultFilters)
      const nonDefaultPeriodExtraFilter = haveFiltersDefaultDatePeriod(filters)
        ? 0
        : 1

      return (
        totalAppliedFiltersNumber -
        defaultFiltersNumber +
        nonDefaultPeriodExtraFilter
      )
    },
    [defaultFilters, type],
  )

  useEffect(() => {
    if (isNearElement) fetchNextPage()
  }, [isNearElement, fetchNextPage])

  return {
    data,
    isLoading,
    visorRef: fromRef,
    filters,
    resetFilters,
    updateFilters,
    appliedFiltersNumber: getAppliedFiltersNumber(filters),
  }
}

export default useShippingsTab
